import { Routes, Route } from "react-router-dom";

import Home from "../../Pages/signO/Home";
import Login from "../../Pages/signO/Login";
import Signup from "../../Pages/signO/Signup";
import Dashboard from "../../Pages/signO/Dashboard";
import BlockchainPage from "../../Pages/signO/BlockchainPage";
import KYCPage from "../../Pages/signO/KYCPage";
import DashboardFeaturesPage from "../../Pages/signO/DashboardFeaturesPage";
import LegalPage from "../../Pages/signO/LegalPage";
import PublicLayout from "../../components/signO/ui/PublicLayout";
import ScrollToTop from "../../components/signO/ui/ScrollToTop";

const SignORoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route index element={<Home />} />
          <Route path="blockchain" element={<BlockchainPage />} />
          <Route path="kyc" element={<KYCPage />} />
          <Route
            path="dashboard-features"
            element={<DashboardFeaturesPage />}
          />
          <Route path="legal" element={<LegalPage />} />
        </Route>

        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="dashboard" element={<Dashboard />} />
      </Routes>
    </>
  );
};

export default SignORoutes;
